import * as c from './types';

import { createImmerReducer } from '../../reducers/utils/createReducer';

type Status = 'idle' | 'loading' | 'success' | 'error';

interface DowntimesPareto {
  companySummary: {
    status: Status;
    data: {
      shiftTitles: string[];
      firstShiftStartDate: string;
      lastCompanyShifts: [];
    };
    error?: any;
  };
}

const initialState: DowntimesPareto = {
  companySummary: {
    status: 'idle',
    data: {
      shiftTitles: [],
      firstShiftStartDate: '',
      lastCompanyShifts: []
    },
    error: undefined
  }
};

export default createImmerReducer(initialState, {
  [c.GET_COMPANY_SUMMARY_REQUEST]: (draft: DowntimesPareto) => {
    draft.companySummary = {
      status: 'loading',
      error: undefined,
      data: {
        shiftTitles: [],
        firstShiftStartDate: '',
        lastCompanyShifts: []
      }
    };
  },
  [c.GET_COMPANY_SUMMARY_SUCCESS]: (draft: DowntimesPareto, { payload }) => {
    const { shiftTitles, firstShiftStartDate, lastCompanyShifts } = payload;
    draft.companySummary = {
      data: {
        shiftTitles,
        firstShiftStartDate,
        lastCompanyShifts
      },
      status: 'success'
    };
  },
  [c.GET_COMPANY_SUMMARY_ERROR]: (draft: DowntimesPareto, { payload }) => {
    draft.companySummary = {
      data: {
        shiftTitles: [],
        firstShiftStartDate: '',
        lastCompanyShifts: []
      },
      error: payload,
      status: 'error'
    };
  }
});
